<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    export default {
        UiNav: defineAsyncComponent(() => import(/* webpackChunkName: "ui-nav" */'@/components/UI/Nav/Nav.vue')),
        UiNavItem: defineAsyncComponent(() => import(/* webpackChunkName: "ui-nav" */'@/components/UI/Nav/Item.vue')),
    }
</script>